import React from "react";
import PageBanner from "../../components/common/PageBanner";
import ContactsSection from "../../components/User/Contact/ContactsSection";
import GetInTouchSection from "../../components/User/Contact/GetInTouchSection";
import { useState, useEffect } from "react";
import axios from "axios";

const Contact = () => {
  const [bannerData, setBannerData] = useState({});
  const [bannerloading, setBannerLoading] = useState(false);

  const getBannerData = () => {
    setBannerLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/contact`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBannerData(response.data);
        setBannerLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setBannerLoading(false);
      });
  };

  useEffect(() => {
    getBannerData();
  }, []);
  return (
    <div>
      {bannerloading ? (
        <BannerSkeleton />
      ) : (
        <PageBanner
          title={bannerData.title}
          subtitle={bannerData.subtitle}
          background={bannerData.bgImage}
        />
      )}
      <ContactsSection />
      <GetInTouchSection />
    </div>
  );
};

export default Contact;
const BannerSkeleton = () => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 px-4 md:px-8 lg:px-12 animate-pulse">
      <div className="absolute inset-0 bg-gray-300/50"></div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="h-8 w-40 bg-gray-400/60 rounded-md mb-4"></div>
        <div className="h-4 w-64 bg-gray-400/50 rounded-md"></div>
      </div>
    </div>
  );
};
